import { Component, h, Prop } from '@stencil/core';
import { FontType, toLocalSeparator } from '@ugc-utils/utils';
import { Star, Camera, Message, LinedThumbsUp } from '../../../../icons';

@Component({
  tag: 'ugc-review-profile-summary',
  shadow: false,
})
export class UgcReviewProfileSummary {
  @Prop() reviewCount: number = 0;
  @Prop() imageCount: number = 0;
  @Prop() answerCount: number = 0;
  @Prop() helpfulCount: number = 0;
  @Prop() fontType: FontType = FontType.large;
  render() {
    const fontType = this.fontType === FontType.large ? 'fs-14' : 'fs-12';
    return (
      <div class="flex-row-start-center gap-16 flex-wrap">
        <div class="flex-row-start-center gap-4">
          <Star width="16" height="16" />
          <span class={`${fontType} color-gray-600`}>{toLocalSeparator(this.reviewCount)}</span>
        </div>

        <div class="flex-row-start-center gap-4">
          <Camera width="16" height="16" />
          <span class={`${fontType} color-gray-600`}>{toLocalSeparator(this.imageCount)}</span>
        </div>
        <div class="flex-row-start-center gap-4">
          <Message width="16" height="16" />
          <span class={`${fontType} color-gray-600`}>{toLocalSeparator(this.answerCount)}</span>
        </div>
        <div class="flex-row-start-center gap-4">
          <LinedThumbsUp width="16" height="16" />
          <span class={`${fontType} color-gray-600`}>{toLocalSeparator(this.helpfulCount)}</span>
        </div>
      </div>
    );
  }
}
